import { globalTranslate } from '@pfsc/shared/locale/app.i18n';

/** Package type */
export class PackageType {
  constructor(data) {
    this.name = data.name;
    this.value = data.value;
  }
}

export const PACKAGE_TYPE = {
  ELearning: new PackageType({
    name: globalTranslate('packageType.elearning'),
    value: 'course',
  }),
  InPerson: new PackageType({
    name: globalTranslate('packageType.inPerson'),
    value: 'class',
  }),
  ProctorU: new PackageType({
    name: globalTranslate('packageType.proctoru'),
    value: 'proctoru',
  }),
};

export const PACKAGE_TYPES = Object.values(PACKAGE_TYPE);
